var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemHomeIconStroke(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ADD8E6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,1.6c0.2,0,0.5,0.1,0.7,0.3l11.4,11.6c0.3,0.3,0.4,0.8,0.2,1.2l0,0l0,0c-0.1,0.4-0.5,0.6-0.9,0.6h-0.7h-1.6 v1.6l0,8.3c0,0.3-0.1,0.6-0.3,0.8c-0.2,0.2-0.5,0.4-0.8,0.4h-4.1v-6.6c0-1.1-0.9-2.1-2-2.1l-0.1,0h0h-3.8c-1.1,0-2.1,0.9-2.1,2.1 l0,0.1l0,0v6.6l-4,0c-0.6,0-1.1-0.5-1.1-1.2v-8.3v-1.6H3.3H2.6c-0.4,0-0.7-0.2-0.9-0.6l0,0l0,0c-0.2-0.4-0.1-0.9,0.2-1.2L13.3,1.9 C13.5,1.7,13.8,1.6,14,1.6 M14,0c-0.7,0-1.3,0.3-1.8,0.8L0.8,12.3c-0.8,0.8-1,1.9-0.6,2.9c0.4,1,1.3,1.7,2.4,1.7c0,0,0,0,0,0h0.7 v8.3c0,0,0,0,0,0C3.3,26.7,4.5,28,6,28h5.6v-8.2c0,0,0,0,0,0c0-0.3,0.2-0.5,0.5-0.5c0,0,0,0,0,0h3.8c0,0,0,0,0,0c0,0,0,0,0,0 c0.3,0,0.5,0.2,0.4,0.5V28H22c0,0,0,0,0,0c1.5,0,2.7-1.3,2.7-2.8v-8.3h0.7c0,0,0,0,0,0c1.1,0,2-0.7,2.4-1.7c0.4-1,0.2-2.1-0.6-2.9 L15.8,0.8c0,0,0,0,0,0C15.3,0.2,14.6,0,14,0L14,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,24.7L21.8,24.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemHomeIconStroke);
export default __webpack_public_path__ + "static/media/item_home_icon_stroke.0c72b072961e41436d3debf03aca9bb3.svg";
export { ForwardRef as ReactComponent };